import Doughnut from './Doughnut';
import Content from './DoughnutContent';
import Filled from './FilledDoughnut';
import Wrapper from './DoughnutWrapper';

Doughnut.Content = Content;
Doughnut.Filled = Filled;
Doughnut.Wrapper = Wrapper;

export default Doughnut;
export {Content, Filled, Wrapper};
// export { default as DoughnutWithContentAndFill } from './DoughnutWithContentAndFill';
